/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component } from 'react';
import { History, UnregisterCallback } from 'history';

import { reactMethodNames } from './reactMethodNames';
/**
 * @deprecated prefer function components instead or bind methods as instance properties with arrow functions.
 * ie.
 * handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {};
 * The base component that autobinds all the methods to this.
 */
export default class BaseComponent<Props = {}, State = {}> extends Component<Props, State> {
  unblock!: UnregisterCallback;

  constructor(props: Props) {
    super(props);

    Object.getOwnPropertyNames(Object.getPrototypeOf(this)).forEach((method) => {
      if (typeof (this as any)[method] !== 'function' || reactMethodNames.indexOf(method) !== -1) {
        return;
      }
      (this as any)[method] = (this as any)[method].bind(this);
    });
  }

  componentDidMount() {
    const {
      props: { history },
      willTransition,
    } = this as any;

    if (history && willTransition) {
      this.unblock = (history as History).block(willTransition);
    }
  }

  componentWillUnmount() {
    if (this.unblock) {
      this.unblock();
    }
  }
}
